document.addEventListener('DOMContentLoaded', () => {
  // ----- Main Slider (with arrows) -----
  function setCenterItem(row) {
    const items = Array.from(row.querySelectorAll('.custom-homepage__slider-item'));
    if (items.length === 0) return;
    
    if (window.innerWidth >= 992) {
      items.forEach(item => item.classList.remove('custom-homepage__slider-item--center'));
      return;
    }
    
    const midIndex = Math.floor(items.length / 2);
    items.forEach(item => item.classList.remove('custom-homepage__slider-item--center'));
    items[midIndex].classList.add('custom-homepage__slider-item--center');
  }

  function nextSlide(row) {
    const first = row.firstElementChild;
    if (first) {
      row.appendChild(first);
    }
    setCenterItem(row);
  }

  function prevSlide(row) {
    const last = row.lastElementChild;
    if (last) {
      row.insertBefore(last, row.firstElementChild);
    }
    setCenterItem(row);
  }

  document.querySelectorAll('.custom-homepage__slider-wrapper').forEach(wrapper => {
    const row = wrapper.querySelector('.custom-homepage__slider-row');
    const btnLeft = wrapper.querySelector('.custom-homepage__slider-arrow--left');
    const btnRight = wrapper.querySelector('.custom-homepage__slider-arrow--right');
    if (!row || !btnLeft || !btnRight) return;
    setCenterItem(row);
    btnRight.addEventListener('click', () => nextSlide(row));
    btnLeft.addEventListener('click', () => prevSlide(row));
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.custom-homepage__slider-wrapper').forEach(wrapper => {
      const row = wrapper.querySelector('.custom-homepage__slider-row');
      if (row) {
        setCenterItem(row);
      }
    });
  });

  // ----- Envelopes Suggestions Slider (automatic fade) -----
  const suggestionsSlider = document.querySelector('.custom-homepage__suggestions-slider');
  if (suggestionsSlider) {
    const suggestionItems = Array.from(suggestionsSlider.querySelectorAll('.custom-homepage__suggestions-item'));
    if (suggestionItems.length > 0) {
      let currentIndex = 0;
      // Initialize slides: make the first slide active
      suggestionItems.forEach((item, index) => {
        if (index === 0) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
      
      function showNextSuggestionSlide() {
        suggestionItems[currentIndex].classList.remove('active');
        currentIndex = (currentIndex + 1) % suggestionItems.length;
        suggestionItems[currentIndex].classList.add('active');
      }
      
      // Automatically change slide every 5 seconds
      setInterval(showNextSuggestionSlide, 5000);
    }
  }
});